import { Collapse, Icon, Button, Tooltip, Popover, Input, message } from 'antd';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import LaneContainer from '../UI/LaneContainer';
import { connectToTitle } from './containers/TitleDataStore';
import TitleBaseMeta from './UI/TitleBaseMeta';
import { TitleExport } from '../Titles/Export/TitleExport';
import BiblioImageGalleryModal from './UI/BiblioImageGalleryModal/BiblioImageGalleryModal';
import { Translate } from '@above-the-treeline/localization';
import TitleBiblioDescriptionsEnum from './TitleBiblioDescriptionsEnum';
import { connectToUser } from '../User/containers/UserDataStore';
import { connectToAccountOrMembershipRequiredModalContext } from '../Anonymous/AccountOrMembershipRequiredModal/contexts/AccountOrMembershipRequiredModalContext';
import combineConnectors from '../util/combineConnectors';
import DrcActionsCard from './DrcActionsCard';
import './titleBiblio.less';
import ParseContent from '../ParseContent';

const Panel = Collapse.Panel;

const titleBiblioDescriptionsKeys = Object.keys(TitleBiblioDescriptionsEnum);

export class TitleBiblio extends React.Component {
	state = {
		galleryModal: {
			isVisible: false,
			startIndex: 0,
		},
	};

	render() {
		const {
			titleDataStore,
			userDataStore: { isAnonymous },
			accountOrMembershipRequiredModalContext: { setIsVisible },
			isMobile,
		} = this.props;
		const {
			isProductDataLoading,
			title,
			isCollaborativeListDataLoading,
			collaborativeLists,
		} = titleDataStore.state;

		if (!isProductDataLoading && !isCollaborativeListDataLoading) {
			const {
				downloadableSkus,
				requestableSkus,
				digitalCopyInfo,
			} = collaborativeLists;
			title.isDownloadable =
				downloadableSkus && downloadableSkus.includes(title.sku);
			title.isRequestable =
				requestableSkus && requestableSkus.includes(title.sku);

			const availableReviewCopyFormats = digitalCopyInfo.filter(
				dci => dci.sku === title.sku,
			);
			title.availableReviewCopyFormats = availableReviewCopyFormats;

			if (
				availableReviewCopyFormats &&
				availableReviewCopyFormats.length &&
				availableReviewCopyFormats[0]
			) {
				var availableReviewCopyFormat = availableReviewCopyFormats[0];
				title.digitalCreatedDate =
					availableReviewCopyFormat.createdDate;
				title.digitalUpdatedDate =
					availableReviewCopyFormat.updatedDate;
			}
		}

		const hasInteriors =
			title &&
			title.images &&
			title.images.filter(im => im.type === 'interior').length > 0;
		const { disableLink, source } = this.props;
		return (
			<div className="title-biblio">
				{!isProductDataLoading &&
					isMobile() &&
					(title.isDownloadable || title.isRequestable) && (
						<div style={{ marginBottom: 10 }}>
							<DrcActionsCard title={title} />
						</div>
					)}
				{!isProductDataLoading && (
					<LaneContainer>
						{title.sku ? (
							<>
								<div style={{ paddingRight: '20px' }}>
									<TitleBaseMeta
										product={title}
										disableLink={disableLink && disableLink}
									/>
								</div>
								<Collapse
									defaultActiveKey={
										titleBiblioDescriptionsKeys[0]
									}
									accordion
									className={`collapse-container ${
										isMobile()
											? 'standard-collapse-mobile'
											: 'standard-collapse'
									}`}
									bordered={false}
									expandIcon={({ isActive }) => (
										<Icon
											type="caret-right"
											rotate={isActive ? 90 : 0}
										/>
									)}>
									{hasInteriors &&
										this.getInteriorsPanel(title)}
									{this.getPanels(title)}
								</Collapse>
							</>
						) : (
							<p className="issue-loading-title-details-message">
								<Translate id="issue_loading_title_details" />
							</p>
						)}
					</LaneContainer>
				)}
				{source === 'titleDetail' && title && title.sku && (
					<div className="export">
						{this.renderShareTitleButton()}
						{isAnonymous() ? (
							<div onClick={() => setIsVisible(true)}>
								{this.renderExportTitleInfoButton()}
							</div>
						) : (
							<TitleExport skus={title && title.sku.split(',')}>
								{this.renderExportTitleInfoButton()}
							</TitleExport>
						)}
					</div>
				)}
			</div>
		);
	}

	renderShareTitleButton = () => {
		return (
			<Popover
				trigger="click"
				content={this.renderShareTitleContent()}
				overlayStyle={{
					width: '400px',
				}}>
				<Tooltip title="Share this title">
					<Button shape="circle">
						<div className="icon-share-alt" />
					</Button>
				</Tooltip>
			</Popover>
		);
	};

	renderShareTitleContent = () => {
		const { titleDataStore } = this.props;
		const { title } = titleDataStore.state;
		const { sku } = title;

		const base = window.location.origin;
		const url = `${base}/title/${sku}`;

		const onClick = () => {
			navigator.clipboard.writeText(url);
			message.success('Copied to clipboard.');
		};

		return (
			<div className="share-title-content">
				<Input value={url} />
				<Tooltip title="Copy url to clipboard">
					<Button icon="copy" onClick={onClick} />
				</Tooltip>
			</div>
		);
	};

	renderExportTitleInfoButton = () => {
		return (
			<Tooltip title="Export title information" placement="leftTop">
				<Button shape="circle">
					<div className="icon-export share-icon"></div>
				</Button>
			</Tooltip>
		);
	};

	showBiblioImageGalleyModal = idx => {
		this.setState({ galleryModal: { isVisible: true, startIndex: idx } });
	};

	hideBiblioImageGalleryModal = () =>
		this.setState({ galleryModal: { isVisible: false, startIndex: 0 } });

	getInteriorsPanel(title) {
		const interiors = title.images.filter(im => im.type === 'interior');
		const { isVisible, startIndex } = this.state.galleryModal;
		return (
			<Panel
				header={
					<Translate
						id="images_with_quantity_in_parenthesis"
						data={{ quantity: interiors.length }}
					/>
				}
				key="interiors">
				<BiblioImageGalleryModal
					isVisible={isVisible}
					onCancel={this.hideBiblioImageGalleryModal}
					interiors={interiors}
					startIndex={startIndex}
				/>
				{interiors.map((interior, idx) => (
					<div className="column-spaced images-section" key={idx}>
						<img
							alt={title.name}
							onClick={() => this.showBiblioImageGalleyModal(idx)}
							src={`${interior.uri}?height=360`}
							className="title-image-thumbnail"
						/>
					</div>
				))}
				<div className="clear" />
			</Panel>
		);
	}

	getPanels = title =>
		titleBiblioDescriptionsKeys.map(titleBiblioDescriptionsKey =>
			title &&
			title.descriptions &&
			title.descriptions[titleBiblioDescriptionsKey] ? (
				<Panel
					header={
						<Translate
							id={
								TitleBiblioDescriptionsEnum[
									titleBiblioDescriptionsKey
								].LocalizeId
							}
						/>
					}
					key={titleBiblioDescriptionsKey}>
					<ParseContent
						content={title.descriptions[titleBiblioDescriptionsKey]}
					/>
				</Panel>
			) : null,
		);
}

const connectors = [
	connectToUser,
	connectToAccountOrMembershipRequiredModalContext,
	connectToTitle,
	withIsMobile,
];

export default combineConnectors(connectors)(TitleBiblio);
